import menuEn from './json/menu-en.json'
import menuEnAu from './json/menu-en-au.json'
import menuEnUs from './json/menu-en-us.json'
import menuEnGb from './json/menu-en-gb.json'
import menuEnNz from './json/menu-en-nz.json'
import menuEnCa from './json/menu-en-ca.json'
import menuEnZa from './json/menu-en-za.json'
import type { MenuJsonType } from './Menu'

const defaultMenu: MenuJsonType = menuEnAu as MenuJsonType

const menuByLocale: Record<string, MenuJsonType> = {
  en: menuEn as MenuJsonType,
  'en-AU': defaultMenu,
  'en-US': menuEnUs as MenuJsonType,
  'en-GB': menuEnGb as MenuJsonType,
  'en-NZ': menuEnNz as MenuJsonType,
  'en-CA': menuEnCa as MenuJsonType,
  'en-ZA': menuEnZa as MenuJsonType,
}

export function getMenuJson(locale: string): MenuJsonType {
  return menuByLocale[locale] ?? defaultMenu
}
